import { render, staticRenderFns } from "./BranchCompanys.vue?vue&type=template&id=614beb5c&scoped=true&"
import script from "./BranchCompanys.vue?vue&type=script&lang=js&"
export * from "./BranchCompanys.vue?vue&type=script&lang=js&"
import style0 from "./BranchCompanys.vue?vue&type=style&index=0&id=614beb5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614beb5c",
  null
  
)

export default component.exports